/**
 * WooCommerce Cart Block Integration for Uploadcare PRO
 * 
 * Adds uploaded images display to WooCommerce Cart Block
 */

import { createElement } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';

/**
 * Component to render uploaded images in cart block
 */
const UploadedImagesDisplay = ({ cartItem, extensions }) => {
    const imageData = extensions?.['wcu-pro'];
    
    if (!imageData || !imageData.images || imageData.images.length === 0) {
        return null;
    }

    const { labels } = wcuProCartBlock;

    return createElement(
        'div',
        { className: 'wcu-pro-cart-images' },
        [
            createElement(
                'div',
                { className: 'wcu-pro-images-label', key: 'label' },
                labels.uploadedFiles + ':'
            ),
            createElement(
                'div',
                { className: 'wcu-pro-images-grid', key: 'images' },
                imageData.images.map((image, index) =>
                    createElement(
                        'a',
                        {
                            key: `image-${index}`,
                            href: image.url,
                            target: '_blank',
                            rel: 'noopener noreferrer',
                            className: 'wcu-pro-image-link',
                            title: labels.viewImage
                        },
                        createElement('img', {
                            src: image.thumbnail,
                            alt: `${labels.uploadedFiles} ${index + 1}`,
                            className: 'wcu-pro-cart-image'
                        })
                    )
                )
            ),
            imageData.notice && createElement(
                'div',
                { className: 'wcu-pro-notice', key: 'notice' },
                [
                    createElement('strong', { key: 'notice-label' }, labels.notice + ': '),
                    createElement('span', { key: 'notice-text' }, imageData.notice)
                ]
            )
        ]
    );
};

/**
 * Add uploaded images to cart item details in Cart Block
 */
addFilter(
    'woocommerce.cart-item.details',
    'wcu-pro/cart-item-images',
    (cartItemDetails, cartItem, extensions) => {
        return [
            ...cartItemDetails,
            createElement(UploadedImagesDisplay, {
                key: 'wcu-pro-images',
                cartItem,
                extensions
            })
        ];
    }
);

/**
 * Alternative filter for checkout block if needed
 */
addFilter(
    'woocommerce.checkout-cart-item.details',
    'wcu-pro/checkout-cart-item-images',
    (cartItemDetails, cartItem, extensions) => {
        return [
            ...cartItemDetails,
            createElement(UploadedImagesDisplay, {
                key: 'wcu-pro-checkout-images',
                cartItem,
                extensions
            })
        ];
    }
);

/**
 * Handle cart updates via Store API
 */
document.addEventListener('DOMContentLoaded', function() {
    // Listen for cart updates and refresh image data
    if (typeof wp !== 'undefined' && wp.data) {
        const unsubscribe = wp.data.subscribe(() => {
            const cartData = wp.data.select('wc/store/cart').getCartData();
            if (cartData && cartData.items) {
                // Cart data is automatically handled by Store API extensions
                console.log('WCU Pro: Cart data updated with image information');
            }
        });
    }
    
    // Fallback for manual cart updates
    jQuery(document).on('updated_cart_totals', function() {
        // Re-initialize image display if needed
        setTimeout(() => {
            const imageContainers = document.querySelectorAll('.wcu-pro-cart-images');
            imageContainers.forEach(container => {
                if (container.dataset.wcuProInitialized !== 'true') {
                    container.dataset.wcuProInitialized = 'true';
                }
            });
        }, 100);
    });
});